var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "purchase-order-details-dialog",
      attrs: {
        title: "订单跟进详情页",
        center: "",
        width: "80%",
        visible: _vm.visible,
        top: "0",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "purchase-order-details",
        },
        [
          _c("div", { staticClass: "progress" }, [
            _c(
              "div",
              { staticClass: "el-steps el-steps--horizontal" },
              _vm._l(_vm.poTrackingLinkCodeVoList, function (e, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "el-step is-horizontal",
                    staticStyle: {
                      "flex-basis": "300px",
                      "margin-right": "0px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "el-step__head",
                        class: "is-" + e.currentStatus,
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-step__line",
                            staticStyle: { "margin-right": "0px" },
                          },
                          [_c("i", { staticClass: "el-step__line-inner" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "el-step__icon is-text" },
                          [
                            e.currentStatus !== "success" &&
                            e.currentStatus !== "error"
                              ? _vm._t("icon", [
                                  _c("div", {
                                    staticClass: "el-step__icon-inner",
                                  }),
                                ])
                              : _c("i", {
                                  staticClass: "el-step__icon-inner is-status",
                                  class: [
                                    "el-icon-" +
                                      (e.currentStatus === "success"
                                        ? "check"
                                        : "close"),
                                  ],
                                }),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "el-step__main" }, [
                      _c(
                        "div",
                        {
                          ref: "title",
                          refInFor: true,
                          staticClass: "el-step__title",
                          class: ["is-" + e.currentStatus],
                        },
                        [_vm._t("title", [_vm._v(_vm._s(e.orderLinkName))])],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-step__description",
                          class: ["is-" + e.currentStatus],
                        },
                        [_vm._t("description")],
                        2
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              staticClass: "currCollapse",
              model: {
                value: _vm.collapseActiveNames,
                callback: function ($$v) {
                  _vm.collapseActiveNames = $$v
                },
                expression: "collapseActiveNames",
              },
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { name: "basic" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", {
                      staticClass: "collapseIcon el-icon-arrow-down",
                      class:
                        _vm.collapseActiveNames.indexOf("basic") !== -1
                          ? ""
                          : "active",
                    }),
                    _c("span", { staticClass: "collText" }, [
                      _vm._v("基本信息"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "basic" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "pic" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("picFilter")(
                                    _vm.poTrackingHeadVo.productImage
                                  ),
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 18 } }, [
                            _c(
                              "div",
                              { staticClass: "basic-ino" },
                              [
                                _c("ul", [
                                  _c("li", [
                                    _c("span", [_vm._v("订单编号:")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.poTrackingHeadVo.orderCode)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    [
                                      _c("span", [_vm._v("交货期：")]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.poTrackingHeadVo.returnDateStr
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.poTrackingHeadVo
                                        .orderPropertiesName !== null
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "danger" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.poTrackingHeadVo
                                                    .orderPropertiesName
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.poTrackingHeadVo
                                        .printingChannelName !== null
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "warning" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.poTrackingHeadVo
                                                    .printingChannelName
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("下单日期：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.poTrackingHeadVo.createDate)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("跟单员：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.poTrackingHeadVo.merchandiserName
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("选款人：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.poTrackingHeadVo.payer)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("采购价：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.poTrackingHeadVo.purchasePrice
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("款号：")]),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.poTrackingHeadVo.spu)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("颜色：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.poTrackingHeadVo.colorName)
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("供应商：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.poTrackingHeadVo.supplierName
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("span", [_vm._v("设计师：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.poTrackingHeadVo.designerName
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-bottom": "20px",
                                    },
                                    attrs: {
                                      data: _vm.purchaseOrderSizeVo.dataArray,
                                      border: "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "size",
                                        align: "center",
                                        label: "尺码",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.purchaseOrderSizeVo.tableHead,
                                      function (item) {
                                        return _c(
                                          "el-table-column",
                                          {
                                            key: item.filedCode,
                                            attrs: {
                                              prop: item.filedCode,
                                              align: "center",
                                              label: item.filedName,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[
                                                              item.filedCode
                                                            ]
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("template", { slot: "header" }, [
                                              _c(
                                                "span",
                                                { staticClass: "center" },
                                                [_vm._v(_vm._s(item.filedName))]
                                              ),
                                            ]),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { name: "content" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", {
                      staticClass: "collapseIcon el-icon-arrow-down",
                      class:
                        _vm.collapseActiveNames.indexOf("content") !== -1
                          ? ""
                          : "active",
                    }),
                    _c("span", { staticClass: "collText" }, [
                      _vm._v("资料信息"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _c(
                        "el-tabs",
                        {
                          on: { "tab-click": _vm.handleClick },
                          model: {
                            value: _vm.activeName,
                            callback: function ($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "大货BOM", name: "bulkbom" } },
                            [
                              _c("BulkBom", {
                                attrs: {
                                  "material-color-data-vo-list":
                                    _vm.bigBomVo.materialColorDataVoList,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: { label: "二次工艺", name: "secondCraft" },
                            },
                            [
                              _c("SecondaryProcess", {
                                attrs: {
                                  data: _vm.mesPurchaseSecondaryProcessVo
                                    .mesPurchaseSecondaryProcessDetailList,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "大货核价", name: "price" } },
                            [
                              _c("CheckPrice", {
                                attrs: {
                                  "pdm-pricing-working-procedure-vo":
                                    _vm.pdmPricingWorkingProcedureVo,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "工艺指导书",
                                name: "processInstructionBook",
                              },
                            },
                            [
                              _c("ProcessInstructionBook", {
                                attrs: {
                                  "pdm-process-content-vo":
                                    _vm.pdmProcessContentVo,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "纸样", name: "paperPattern" } },
                            [
                              _c("PaperPattern", {
                                attrs: {
                                  "pdm-cloth-detail-vo": _vm.pdmClothDetailVo,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "裁床", name: "cutting-bed" } },
                            [
                              _c("cutting-bed", {
                                attrs: {
                                  "mes-cutting-bed-size-vo":
                                    _vm.mesCuttingBedSizeVo,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "QC尾查", name: "qc-review>" } },
                            [
                              _c("qc-review", {
                                attrs: {
                                  "check-order-detail-vo-list":
                                    _vm.checkOrderDetailVoList,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "发货", name: "ship" } },
                            [
                              _c("ship", {
                                attrs: {
                                  "po-tracking-delivery-vo":
                                    _vm.poTrackingDeliveryVo,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "流程记录",
                                name: "processRecord",
                              },
                            },
                            [
                              _c("process-record", {
                                attrs: { datas: _vm.poTrackingLinkCodeVoList },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }